<template>
  <div ref="customPageRuntimeRef" class="custom-page-runtime-container">
    <div class="custom-page-runtime-body" ref="controlsBody" >
      <div style="position: absolute;right: 10px;height: 100%" >
        <el-popover
          placement="bottom-end"
          width="200"
          trigger="click"
          v-model="popoverVisible"
          visible-arrow="false"
          >
          <div class="popover-top"><span>勾选您要显示都是模块</span><i class="el-icon-close" @click="popoverVisible=false"></i></div>
          <el-divider></el-divider>
          <div class="check-group">
            <el-checkbox  size="mini" :label="item.title? item.title : '未命名'" v-for="item in customReport.report" :key="item.id" v-model="item.show" @change="updateShow"></el-checkbox>
          </div>
          <div style="text-align: right; margin: 20px 0 0 0 ">
            <el-button size="mini"  @click="cancelChangeShow">取消</el-button>
            <el-button type="primary" size="mini" @click="saveShowItems">确定</el-button>
          </div>
          <el-button style="border: 0;background-color: rgb(0, 0, 0, 0)" slot="reference" class="el-icon-setting">
            设置
          </el-button>
        </el-popover>
      </div>
      <div v-if="choiceControls && choiceControls.length" class="control-body" v-for="item in choiceControls" :key="item.id" :style="getStyle(item)" v-show="item.show">
        <div class="control" v-if="show" >
          <div v-if="item.headTitle.show && item.headTitle.value !== ''"
               class="control-title"
               :title="item.headTitle.value"
               :style="getFontStyle(item.titleFont)">{{item.headTitle.value}}
          </div>
          <el-tooltip v-if="['diagram','report','calendar','clock'].includes(item.type)"
                      popper-class="chart-type-popper" effect="dark" content="放大" placement="bottom">
            <i class="fa fa-arrows-v" aria-hidden="true" @click="magnify(item)"></i>
          </el-tooltip>
          <div :class="['control-content', item.headTitle.show && 'height-title']" :style="getContentStyle(item)">
            <template v-if="item.type === 'diagram'">
              <diagram ref="diagramRuntime" :data="item" :showOperation="false"></diagram>
            </template>
            <template v-else-if="item.type === 'rich-text-box'">
              <div class="rich-value" v-html="item.richValue"></div>
            </template>
            <template v-else-if="item.type === 'url-page'">
              <iframe width="100%" height="100%" :src="disposeUrl(item)" frameborder="0"></iframe>
            </template>
            <template v-else-if="item.type === 'report'">
              <report :data="item" :showOperation="false" :isRuntime="true" :ref="`${item.id}-report`"></report>
            </template>
            <template v-else-if="item.type === 'calendar'">
              <calendar :typeFlag=1 :ref="`${item.id}-calendar`"></calendar>
            </template>
            <template v-else-if="item.type === 'clock'">
              <clock :data="item" :sceneType=1 :ref="`${item.id}-clock`"></clock>
            </template>
            <template v-else-if="item.type === 'text-control'">
              <div class="text-control" :style="getFontStyle(item.textFont)">{{item.textContent}}</div>
            </template>
            <template v-else-if="item.type === 'decorate'">
              <img class="decorate-img" :src="item.decorateUrl" draggable="false">
            </template>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="custom-page-design-dialog custom-page-design-dialog-runtime" top="10vh" title=" "
               v-if="dialog.visable" :visible.sync="dialog.visable" width="1100px" append-to-body center>
      <div class="dialog-body" :style="getBackground">
        <template v-if="dialog.data.type === 'diagram'">
          <diagram :isCustomPageRuntime="true" :data="dialog.data" :showOperation="false"
                   :isCustomPage="false" :isMagnify="true"></diagram>
        </template>
        <template v-else-if="dialog.data.type === 'rich-text-box'">
          <div class="rich-value" v-html="dialog.data.richValue"></div>
        </template>
        <template v-else-if="dialog.data.type === 'url-page'">
          <iframe width="100%" height="100%" :src="disposeUrl(dialog.data)" frameborder="0"></iframe>
        </template>
        <template v-else-if="dialog.data.type === 'report'">
          <report :data="dialog.data" :isRuntime="true" :showOperation="false"></report>
        </template>
        <template v-else-if="dialog.data.type === 'calendar'">
          <calendar :typeFlag=2></calendar>
        </template>
        <template v-else-if="dialog.data.type === 'clock'">
          <clock :data="dialog.data" :sceneType=1></clock>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import diagram from '../design/customPage/diagram'
import report from '../design/customPage/report'
import calendar from '../design/customPage/calendar'
import clock from '../design/customPage/clock'
import setStyle from '../../public/setStyle'
import Controls from '@/components/report/design/customPage/assets/js/controls'
import { watchDom } from '@/utils'
export default {
  name: 'custom-page-runtime',
  props: ['choiceControls', 'width', 'pageSize', 'background', 'reportId'],
  mixins: [setStyle],
  data () {
    return {
      show: true,
      popoverVisible: false,
      dialog: {
        data: {},
        visable: false
      },
      checkList: [],
      customReport: {
        reportId: this.reportId,
        userId: sessionStorage.getItem('userId'),
        report: []
      }
    }
  },
  components: {diagram, report, calendar, clock},
  async created () {
    this.$axios.get(`/report-api/report/data/getShowItems/${this.reportId}`).then(res => {
      if (res.data.report) {
        this.customReport.report = res.data.report
      } else {
        this.customReport.report = []
      }
    })
    this.choiceControls.forEach(item => {
      item.souceTop = item.position.top
    })
  },
  watch: {
    'customReport.report' () {
      this.choiceControls.forEach(item => {
        if (!this.customReport.report.find(i => i.id === item.id)) {
          this.customReport.report.push({
            id: item.id,
            title: item.headTitle.value,
            show: true
          })
        } else {
          this.customReport.report.find(i => i.id === item.id).title = item.headTitle.value
        }
      })
      this.customReport.report.forEach((item, index) => {
        if (!this.choiceControls.find(i => i.id === item.id)) {
          this.customReport.report = this.customReport.report.splice(1, index)
        }
      })
      this.choiceControls.forEach(item => {
        this.customReport.report.find(i => i.id === item.id) ? item.show = this.customReport.report.find(i => i.id === item.id).show : item.show = true
      })
      this.$nextTick(() => {
        this.updateView()
      })
    }
  },
  computed: {
    disposeUrl () {
      return item => {
        let reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
        return reg.test(item.urlValue) ? item.urlValue : `https://${item.urlValue}`
      }
    },
    getStyle () {
      return item => {
        return {
          'top': Number(item.position.top) + 20 + 'px',
          'left': item.position.left + 'px',
          'width': item.width + 'px',
          'height': item.height + 'px',
          'z-index': item.zIndex,
          'background-color': 'transparent'
        }
      }
    },
    getContentStyle () {
      return item => {
        return {
          'border': this.getBorder(item.backgroundAndBorder),
          'background-image': this.getBgcImg(item.backgroundAndBorder),
          'opacity': item.type === 'decorate' ? parseFloat(item.decorateOpacity) / 100 : 1,
          'background-repeat': 'no-repeat',
          'background-size': '100% 100%',
          'background-color': this.getBgc(item.backgroundAndBorder, item)
        }
      }
    },
    // 弹框放大用的，不确定是否真的需要删除，留着
    getBackground () {
      return this.background.src ? {
        'background-image': `url("${this.background.src.includes('/ak0000000386') ? sessionStorage.getItem('ossDownloadUrl') + this.background.src : `${require(`@/components/report/design/${this.background.absoluteSrc}`)}`}")`
      } : ''
    }
  },
  methods: {
    magnify (item) {
      this.dialog.data = this.$_.cloneDeep(item)
      this.$nextTick(() => {
        this.dialog.visable = true
      })
    },
    adapterWidth () {
      if (this.$refs.controlsBody) {
        const width = this.$refs.controlsBody.getBoundingClientRect().width
        if (width && width > 0) {
          const resizeTH = this.$route.path.includes('report-full-screen')
          Controls.adapterWidth(width - 10, this.choiceControls, this.pageSize, resizeTH)
          // 修改宽度的同时，重新渲染
          this.$nextTick(() => {
            this.$refs.diagramRuntime && this.$refs.diagramRuntime.forEach(ref => ref && ref.resizeChartSize())
            this.choiceControls.forEach(it => {
              const reportRef = this.$refs[`${it.id}-report`]
              reportRef && reportRef.length && reportRef[0].resizeChartSize && reportRef[0].resizeChartSize(it)
            })
          })
        }
      }
    },
    watchReportDisplay (adapterWidth) {
      const customPageRuntimeRef = this.$refs.customPageRuntimeRef
      const reportDom = Array.from(document.getElementsByClassName(`${this.reportId}_report`)).find(it => it.contains(customPageRuntimeRef))
      if (reportDom) {
        watchDom(() => reportDom.style.display !== 'none' && adapterWidth && adapterWidth(), reportDom, {
          childList: false,
          attributes: true,
          characterData: false,
          subtree: false
        })
      }
    },
    updateShow () {
      this.choiceControls.forEach(item => {
        this.customReport.report.find(i => i.id === item.id) ? item.show = this.customReport.report.find(i => i.id === item.id).show : item.show = true
      })
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
      this.$nextTick(() => {
        this.updateView()
      })
    },
    saveShowItems () {
      this.popoverVisible = false
      this.$axios.post('/report-api/report/data/saveShowItemsForCustomReport', this.customReport)
    },
    async cancelChangeShow () {
      this.popoverVisible = false
      await this.$axios.get(`/report-api/report/data/getShowItems/${this.reportId}`).then(res => {
        if (res.data.report) {
          this.customReport.report = res.data.report
        } else {
          this.customReport.report = []
        }
      })
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    sortByKey (array, key) {
      return array.sort(function (a, b) {
        let x = a.position[key]
        let y = b.position[key]
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
    },
    updateView () {
      let newAllReport1 = this.sortByKey(this.choiceControls.filter(i => i.show === true), 'top')
      let newAllReport2 = this.sortByKey(this.choiceControls.filter(i => i.show === true), 'top')
      newAllReport1.forEach(item => {
        let mov = []
        let minx = item.position.left + 15
        let maxx = item.position.left + item.width
        let compareArr = newAllReport2.filter(i => i.position.top <= item.position.top && i.souceTop < item.souceTop)
        if (compareArr.length >= 1) {
          compareArr.forEach(view => {
            let minX = view.position.left + 15
            let maxX = view.position.left + view.width
            if ((minx >= minX && minx <= maxX) || (maxx >= minX && maxx <= maxX) || (minX >= minx && maxX <= maxx) || (minX <= minx && maxX >= maxx)) {
              let top = view.position.top + view.height
              mov.push(top)
            }
          })
        }
        if (mov.length === 0) {
          item.position.top = 15
        } else {
          item.position.top = Math.max(...mov)
        }
      })
    }
  },
  mounted () {
    this.updateView()
    const adapterWidth = this.adapterWidth.bind(this)
    adapterWidth()
    window.onresize = this.$_.debounce(adapterWidth)
    // 监听报表的 display属性
    const unWatch = this.$watch(() => this.reportId, reportId => {
      if (report) {
        this.watchReportDisplay(adapterWidth)
        unWatch && unWatch()
      }
    }, { immediate: true })
    this.$nextTick(() => {
      let dom = document.getElementsByClassName('rich-value')
      if (dom && dom.length > 0) {
        for (let i = 0; i < dom.length; i++) {
          // 只处理一层
          let p = dom[i].getElementsByTagName('p')
          if (p && p.length > 0) {
            for (let j = 0; j < p.length; j++) {
              let img = p[j].querySelector('img')
              let iframe = p[j].querySelector('iframe')
              if (img || iframe) {
                p[j].style.width = '100%'
                p[j].style.height = '100%'
              }
            }
          }
        }
      }
    })
  }
}
</script>

<style lang="scss">
  .custom-page-runtime-container {
    width: 100%;
    height: 100%;
    padding-left: 15px;
    background-color: #fafcfe;
    border: 1px solid #e6e6e6;
    border-top: none;
    overflow: hidden;

    .custom-page-runtime-body {
      position: relative;
      background-color: #fafcfe;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      .control-body {
        height: 100%;
        width: 100%;
        position: absolute;
        padding: 0 0 15px 15px;

        .control {
          height: 100%;
          width: 100%;
          border-radius: 4px;
          cursor: pointer;
          background-color: #fff;
          overflow: auto;

          .rich-value {
            padding: 15px;
            width: 100%;
            height: 100%;
            overflow: auto;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .fa-arrows-v {
            position: absolute;
            top: 5px;
            right: 25px;
            z-index: 9999;
            color: #AFB0B1;
            transform: rotate(45deg);
            display: none;
            font-size: 16px;

            &:hover {
              color: #55ACF1;
            }
          }

          &:hover {
            .fa-arrows-v {
              display: inline-block;
            }
          }
        }

        &:hover {
          .fa-arrows-v {
            display: inline-block;
          }
        }

        .control-content {
          height: 100%;
        }

        .height-title {
          height: calc(100% - 40px);
        }

        .control-title {
          width: 100%;
          height: 40px;
          padding: 5px 15px 0 15px;
          line-height: 40px;
          font-family: "SimHei", serif;
          color: #1A1A1A;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .custom-page-design-dialog {
    .el-dialog {
      .el-dialog__header {
        height: 44px;
      }

      .el-dialog__body {
        padding: 0;

        .dialog-body {
          height: 576px;
          width: 1100px;
        }
      }
    }
  }

  .custom-page-design-dialog-runtime {
    .el-dialog {
      .el-dialog__body {
        padding: 0;
        .dialog-body {
          padding: 0;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center center;
        }
      }
    }
  }

  .chart-type-popper {
    padding: 4px 7px;
  }
  .el-popover{
    margin-top: 0!important;
    padding-top: 5px;
    .popover-top{
      color: #a3a3a3;
      span{
        font-size: 11px;
      }
      i{
        margin-left: 37px;
      }
    }
    .check-group{
      max-height: 300px;
      overflow: scroll;
      .el-checkbox{
        display: block;
        margin: 10px 0;
        .el-checkbox__inner{
          border-radius: 50%;
        }
        .el-checkbox__label{
          font-weight: 400;
          font-size: 11px;
          color: black;
        }
      }
      .el-checkbox:hover{
        background-color: #eef6fe;
      }
    }

    .el-divider {
      margin: 3px 0 6px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/custom-page-runtime.vue